import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';

import { SELECTED_USER_PROPTYPE } from 'common/constants/commonPropTypes';
import { SelectedUsersContext } from 'pages/UserPage/context';
import {
  searchHeaderBorderGrey,
} from 'common/constants/colors';

const SelectAllCheckbox = ({ searchResults }) => {
  const { selectedUsers, setSelectedUsers } = useContext(SelectedUsersContext);

  const selectAllUsers = () => [
    setSelectedUsers(searchResults.map(user => user.userId)),
  ];

  const deselectAllUsers = () => [setSelectedUsers([])];

  const onCheckAllChange = () => {
    if (selectedUsers.length < searchResults.length) {
      selectAllUsers();
    } else {
      deselectAllUsers();
    }
  };

  return (
    <div
      style={{
        borderBottom: `1px solid ${searchHeaderBorderGrey}`,
        borderRight: `1px solid ${searchHeaderBorderGrey}`,
        display: 'flex',
        padding: '10px 75px',
      }}
    >
      <Checkbox
        checked={selectedUsers.length === searchResults.length}
        indeterminate={!!selectedUsers.length && selectedUsers.length < searchResults.length}
        onChange={onCheckAllChange}
      />
    </div>
  );
};
SelectAllCheckbox.propTypes = { searchResults: PropTypes.arrayOf(SELECTED_USER_PROPTYPE) };
SelectAllCheckbox.defaultProps = { searchResults: [] };

export default SelectAllCheckbox;
